import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../Context/PageContext";
import EditImg from "./img/border_color_black.png"
import DeleteImg from "./img/delete_foreve.png"
import NumberIcon from "./img/pin.png"
import LoginIcon from "./img/account_box.png"
import GenderIcon from "./img/wc.png"
import LoginCountIcon from "./img/sort.png"
import ActionIcon from "./img/more_vert.png"
import CharAmountIcon from "./img/groups.png"
import UltimoLogIcon from "./img/history.png"
import VipStarIcon from "./img/star.png"
import JobName from "./acessos/JobName";
import GoldStar from "./img/goldstar.png"
import ArrowLeft from "./img/keyboard_arrow_left.png"
import ArrowRight from "./img/keyboard_arrow_right.png"
import { ApiConnectUserAccessList, ApiConnectUserCharList } from "../../../api/ServerApiConect";
import PopMenuWindow, { OpenPopMenu } from "../../../PopMenuWindow/PopMenuWindow";
import CriarNovoAcesso from "./acessos/RegisterNewAccess";
import DeleteRegister from "./acessos/DeleteRegister";
import ChangeAccessPassword from "./acessos/ChangeAccessPassword";
import NotAuthorizedDeleteOperation from "./acessos/NotAuthorizedDeleteOperation";
import UserNotLogged from "./UserNotLogged";
import CharacterListContainer from "./acessos/CharacterListContainer";



function AcessosMobile() {

    const className = JobName();

    var charCarrouselOpen = false;
    
    const { user, userCharacters, setUserCharacters, setPopMenuContent, managedAccess, setManagedAcess, userAccessList, setUserAccessList, setPage, setIsLogged } = useContext(PageContext);

    var AccessList = userAccessList;

    useEffect(() => {

        let resultPromise = ApiConnectUserAccessList(user);
        resultPromise.then((response) => {

            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                setIsLogged(false);
                return;
                }

            setTimeout(() => {  document.getElementById("MasterAcessoContainer").style.opacity = 1;

            if(response.data === false) { 
                setUserAccessList([])
                setUserCharacters([])
                return;

            }
            setUserAccessList(response.data);

            let resultCharList = ApiConnectUserCharList(response.data);
            resultCharList.then((response2) => setUserCharacters(response2));
        });

    }, 200)
            },[])


    function colapsideCharCarrousel(id){

        let carrousselChar = document.getElementById(id);

        if(charCarrouselOpen === false) {
            carrousselChar.style.height = "400px";
            charCarrouselOpen = true;
        } else {
            carrousselChar.style.height = "0px";
            charCarrouselOpen = false;
        }

    }

    function scrollCharacterListLeft (event){

        let carroussel = event.target.nextElementSibling;



        let carrouselMarginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0])

        if (carrouselMarginLeft === 0) { return ;}

        if(carrouselMarginLeft < (-240)){
            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) + 240 + "px";
            return;
        } 
        
        if(carrouselMarginLeft > -240 && carrouselMarginLeft < 0){
            carroussel.style.marginLeft = "0px";
        }


    }

    function scrollCharacterListRight (event) {

        let carroussel = event.target.previousElementSibling;
        let carrousselFather = carroussel.offsetParent;
        let carrouselSize = carroussel.children.length * 240;

        let boundary = carrouselSize - carrousselFather.getBoundingClientRect().width;
        let carrouselMarginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]);
        let avaliableDisplacement = boundary + carrouselMarginLeft; 

        if(boundary <= 0){ return }

        if (avaliableDisplacement >= 240 ){ 
            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) - 240 + "px";
            return;
        } else {

            carroussel.style.marginLeft = parseInt(window.getComputedStyle(carroussel).marginLeft.split("p")[0]) - avaliableDisplacement + "px";
        }


    }

    return(
        <MasterAcessoContainer id="MasterAcessoContainer">
            <BannerContainer>
               
                <TitleContainer>
                    <Title>Lista de acessos existentes</Title>
                    <Span>
                        Abaixo segue a lista de todos os acessos existentes em sua conta
                        <br/>
                        Para logar no servidor é preciso criar um novo acesso através do menu "Acessos".
                    </Span>
                </TitleContainer>
            </BannerContainer>

            <AcessoCabecalho>
                <AcessoCabecalhoItem><CabecalhoIcon img={LoginIcon}/>login</AcessoCabecalhoItem>
                
            </AcessoCabecalho>

            {
            AccessList.map((item) => {

                var character_slots = userCharacters.filter(char => char.account_id == item.account_id).length

                var VIPActive = "";
                var amountOfDays ="";

                if(item.group_id < 1) { VIPActive = " - " ; amountOfDays = "" } 
                else { VIPActive = <VipStarIconGold icon={GoldStar}/>; amountOfDays = item.vip_time + " Dias"}

                var AcessoItem =  <AcessoContainer onClick={() => colapsideCharCarrousel(item.account_id)}>
                                    <AcessoItemContainer>{item.userid}</AcessoItemContainer>
                                    <AcessoItemContainer>{VIPActive} {amountOfDays}</AcessoItemContainer>
                                    <AcessoItemContainer>
                                        <Edit 
                                        onClick={() => {
                                                OpenPopMenu();
                                                setManagedAcess(item)
                                                setPopMenuContent(<ChangeAccessPassword/>)
                                            }}
                                        />
                                        <Delete 
                                        onClick={() => {
                                            if(item.vip_time > 0) {
                                                OpenPopMenu();
                                                setPopMenuContent(<NotAuthorizedDeleteOperation/>);
                                                return;
                                            }
                                                OpenPopMenu();
                                                setManagedAcess(item)
                                                setPopMenuContent(<DeleteRegister/>)
                                            }}
                                        />

                                    </AcessoItemContainer>
                             </AcessoContainer>;   
                           return <>
                                {AcessoItem}
                                <CharacterCarrousel id={item.account_id}>
                                    <LeftArrow icon={ArrowLeft} onClick={(e) => scrollCharacterListLeft(e)}/>
                                     <CharacterListContainer userCharacters={userCharacters} itemAccount={item}/>
                                    <RightArrow icon={ArrowRight} onClick={(e) => scrollCharacterListRight(e)}/>
                                </CharacterCarrousel>
                            </>;
              })}


            <AcessoContainerNewAccount>
                <AcessoItemContainerNewAccount onClick={() => {
                    OpenPopMenu();
                    window.scrollTo(0, 1020);
                    if(userAccessList.length < 5) {
                        setPopMenuContent(<CriarNovoAcesso />)
                    } else {
                        setPopMenuContent(<NotAllowedMoreAccounts>
                            Você atingiu o máximo de<br/>Acessos permitidos no momento.
                        </NotAllowedMoreAccounts>)
                    }
                    }}>Novo Acesso +</AcessoItemContainerNewAccount>
            </AcessoContainerNewAccount>
            
        </MasterAcessoContainer>
    
    );
}

export default AcessosMobile;


const MasterAcessoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    //width: 1280px;
    height: 100%;
    //border: solid 2px black;
    width: 100%;
    opacity: 0;
    transition: .7s ease-in-out;
    //box-shadow: 0px 0px 10px 0px black;
    padding: 0px 0px;
    margin-bottom: 200px;

`

const AcessoCabecalho = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    width: 100%;
    margin: 5px 0;
    border-radius: 10px;
    background-color: rgba(72, 72, 72, 0.8);
    color: white;
    overflow: hidden;
    height: 50px;
`

const CabecalhoIcon = styled.div`
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    width: 25px;
    height: 25px; 
    background-blend-mode: multiply;
`

const AcessoCabecalhoItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    //border: solid 2px black;
    width: 160px;
    height: 60px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;

    @media(Max-width: 1280px) {
    width: 110px;

    }

`

const AcessoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    width: 100%;
    margin: 5px 0;
    transition: .3s ease-in-out;

    &:hover {
    transform: translate(0px, 0px);
    background-color: rgba(65, 102, 137, 0.8);
    color: white;

    }

`

const AcessoItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid 2px black;
    width: 100%;
    font-size: 18px;
    height: 50px;
    text-align: center;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

`

const Edit = styled.div`
    background-image: url(${EditImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    width: 25px;
    height: 25px;
    margin-right: 30px;
    z-index: 3;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    scale: 1.8;
    }

`
const Delete = styled.div`
    background-image: url(${DeleteImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border-radius: 5px;
    width: 25px;
    height: 25px;
    z-index: 3;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    transition: .3s ease-in-out;

    &:hover {
    scale: 1.8;
    }
`

const AcessoContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    color: white;
    width: 100%;
    height: 50px;
    margin: 20px 0;
    
`

const AcessoItemContainerNewAccount = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    //border: solid 2px black;
    width: 130px;
    height: 50px;
    opacity: .8;
    text-align: center;
    border-radius: 10px;
    background-color: rgb(26, 144, 67);
    font-size: 12pt;
    transition: .3s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    }
`

const KafraChibi = styled.div`
    background-image: url(${props => props.img});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100px;
    height: 75px;
`

const BannerContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid 2px black;
    border-radius: 10px;

    @media(max-width: 1000px) {
    width: 90vw;
    text-align: justify;
    margin-bottom: 20px;
    //border: solid 1px rgba(0,0,0, 1);
    }
`

const TitleContainer = styled.h1`
    display: flex;
    flex-direction: column;
    //border: solid 2px black;
    padding: 0;
    margin-left: 30px;
    
`;

const Span = styled.span`
    font-size: 18px;
    font-weight: normal;
    //border: solid 2px black;
     padding: 0;
     text-align: center;
     margin: 10px;

     @media(max-width: 1000px) {
    width: 100%;
    text-align: justify;
    margin: 0px;
    }
`;

const Title = styled.h3`
    text-align: center;
    //border: solid 2px black;
    padding: 0;
    margin: 0px 0;
`;


const CharacterCarrousel = styled.div`
    //border: solid 1px black;
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 100%;
    position: relative;
    height: 0px;
    border-radius: 10px;
    //border: solid 1px blue;
    transition: .3s ease-in-out;
    position: relative;

    
`

const LeftArrow = styled.div`
    width: 50px;
    height: 50px;
    top: 0px;
    left: 0%;
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    z-index: 2;
    opacity: .5;
    transition: .3s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    scale: 1.2;
    }
`

const RightArrow = styled.div`
    width: 50px;
    height: 50px;
    top: 0px;
    right: 0%;
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;

    position: absolute;
    z-index: 2;
    opacity: .5;
    transition: .3s ease-in-out;
    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
    opacity: 1;
    scale: 1.4;
    }
`

const VipStarIconGold = styled.div`
    background-image: url(${props => props.icon});
    background-size: cover;
    backrgound-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    margin-right: 20px;
`

const NotAllowedMoreAccounts = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 50px;
    background-color: white;
    border-radius: 10px;
    font-size: 30px;

`